<div class="card">
  <div class="card-body">
    <div class="p-3" *ngIf="HasAdd">
      <div class="row">
        <div class="col-lg-4">
          <input [(ngModel)]="SettingLabel" placeholder="Item" type="text" name="voce" (keyup.enter)="add()" class="form-control">
        </div>
        <div class=" mt-3 mt-md-0 p-1">
          <button class="btn btn-outline-info rounded-pill" style="width: 100%;" (click)="add()" type="button">Aggiungi</button>
        </div>
      </div>
    </div>
    <div class="table-responsive">
      <table class="table bg-white table-hover align-middle mb-0 no-wrap">
        <thead>
        <tr>
          <th> ID </th>
          <th> Item </th>
        </tr>
        </thead>
        <tbody>
        <tr *ngFor="let co of Settings">
          <td >
        <span class="text-dark font-medium font-16">
            <span class="badge badge-light text-dark rounded-pill font-16 mr-1">
              <i-feather name="info" class="feather-sm"></i-feather>
            </span>
          {{ co.id}}
          </span>
          </td>
          <td>
        <span class="text-dark font-medium font-16" *ngIf="!co.isInModify">
          <span class="badge badge-light text-dark rounded-pill font-16 mr-1">
            <i-feather name="info" class="feather-sm"></i-feather>
          </span>
          {{ co.label}}
        </span>
            <span *ngIf="co.isInModify">
          <input [(ngModel)]="co.label" placeholder="voce" type="text" name="voce" class="form-control">
        </span>
          </td>
          <td class="align-middle">
            <a *ngIf="!co.isInModify"  href="javascript:void(0)" ngbTooltip="Modifica" class="link font-16 text-info font-medium mr-2"
               (click)='edit(co)'>
              <i-feather name="edit-3" class="feather-sm"></i-feather>
            </a>
            <a *ngIf="!co.isInModify"  href="javascript:void(0)" ngbTooltip="Traduzioni" class="link font-16 text-info font-medium mr-2"
               (click)='openModal(settingsTranslationsModal, co)'>
              <i class="mdi mdi-translate "></i>
            </a>
            <a *ngIf="co.isInModify" href="javascript:void(0)" ngbTooltip="Salva" class="link font-16 text-success font-medium mr-2" (click)='edit(co)'>
              <i-feather name="check" class="feather-sm"></i-feather>
            </a>
            <a *ngIf="!co.isInModify" href="javascript:void(0)" ngbTooltip="Elimina"
               class="link font-16 text-danger font-weight-bold" (click)='delete(co)'>
              <i-feather name="trash-2" class="feather-sm"></i-feather>
            </a>
            <a *ngIf="co.isInModify" href="javascript:void(0)" ngbTooltip="annulla"
               class="link font-16 text-danger font-weight-bold" (click)='delete(co)'>
              <i  class="fas fas fa-times"></i>
            </a>
          </td>
        </tr>
        </tbody>
      </table>
    </div>

  </div>
</div>

<ng-template #settingsTranslationsModal let-modal>
  <div class="modal-header">
    <h5 class="modal-title" id="editUserLabel">Settings Translations</h5>
    <button type="button" class="close" (click)="closeBtnClick()" aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body">
    <div class="row">
      <div class="col-12">
        <app-translated-desc [(data)]="transaltedobjects"></app-translated-desc>
      </div>
    </div>
    <div class="d-md-flex align-items-center p-3" style="padding-right: 25px;">
      <button type="submit" (click)="saveModalButton()" class="ml-auto btn btn-rounded btn-success p-2 waves-effect waves-light">
        <span class="ml-1 text-white font-weight-bold"> Salva </span>
        <i-feather name="save" class="feather-md "></i-feather>
      </button>
    </div>
  </div>
</ng-template>
